import Ajax from '../util/ajax';
export function actionColorTemperature(id, value) {
    return (dispatch) => {
        const a = new Ajax(dispatch, true);
        a.post('/action/' + id + '/exec', value);
    };
}
